<template>
  <div style="min-height: 92vh">
    <h3>Zonas de impresión</h3>
    <uv-data-table
      :config="config"
      :data="departamentos"
      :pageRows="15"
      @buttonClick="dtButtonClick"
    ></uv-data-table>
    <modal ref="modalForm" v-model="showModal" :showFooter="false">
      <ZonasForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </ZonasForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../MainComponents/modal.vue";
import uvDataTable from "../MainComponents/DataTable.vue";
import ZonasForm from "../ZonaImpresion/ZonasForm.vue";

export default {
  name: "ZonasImpresionCRUD",
  components: {
    modal,
    uvDataTable,
    ZonasForm,
  },
  props: [],
  data() {
    return {
      formIndex: 0,
      formHeight: 0,
      editMode: false,
      departamentos: [],
      editData: {},
      showModal: false,
      config: {
        selectableRow: true,
        selectConfig: {
          idRowData: "Id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Agregar zona de impresión",
            icon: "lni lni-plus",
            buttonId: "addZona",
            require: false,
          },
          {
            text: "Editar zona de impresión",
            icon: "lni lni-pencil-alt",
            buttonId: "editZona",
            require: true,
          },
          {
            text: "Eliminar zona de impresión",
            icon: "lni lni-trash",
            buttonId: "eliminarZona",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "Nombre",
            text: "Nombre",
            value: "nomb",
          },
          {
            text: "Departamento",
            value: "dpto",
          },
          {
            text: "Activo",
            value: "actvo",
            format: (row) => {
              if (row["actv"]) {
                return "activo";
              } else {
                return "Inactivo";
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addZona") {
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar Zona Impresión");
        this.showModal = true;
      } else if (buttonId == "editZona") {
        const cashier = this.$pgsHelper.getById(
          this.departamentos,
          "Id",
          idSelected[0]
        );

        this.editMode = true;
        this.editData = cashier;
        this.$pgsHelper.log(this.editData);
        this.$refs.modalForm.setTitle(`Editar Zona Impresión`);
        this.showModal = true;
      } else if (buttonId == "eliminarZona") {
        this.deleteZonasImpresion(idSelected[0]);
      }
    },
    optButtonClick() {},
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.addZona(data);
      } else if (doAction == "EDIT") {
        this.editZonasImpresion(data);
      }
    },
    deleteZonasImpresion(Id) {
      let datos = { Id }; //localStorage.getItem("selectedDepartment");
      this.$swal({
        title: "¿Deseas eliminar esta zona de impresión?",
        text: "Se eliminará permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Departamentos-deleteZonasImpresion", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.getZonasImpresion();
            this.$swal(
              "Departamento eliminado",
              "El departamento se eliminó correctamente",
              "success"
            );
          } else {
            this.$swal(
              "Error deleting departamento",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    addZona(datos) {
      this.$swal({
        title: "¿Deseas guardar la información de la zona de impresión?",
        text: "La zona de impresión se almacenará y podrá empezar a usarse",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-ZonasImpresion-createZonaImpresion", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "El Departamento se guardó correctamente",
              icon: "success",
            }).then(() => {
              this.getZonasImpresion();
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving Departamento",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editZonasImpresion(datos) {
      this.$swal({
        title: "¿Deseas editar esta zona de impresión?",
        text: "Los cambios se verán reflejados inmediatamente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-ZonasImpresion-updateZonaImpresion", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "El departamento se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.getZonasImpresion();
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error guardando departamento",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getZonasImpresion() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "/PDV/ZonasImpresion"
        );
      if (snapshot.exists()) {
        this.departamentos = [];
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.departamentos.push(toAdd);
          }
        });
      }
    },
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.getZonasImpresion();
  },
};
</script>
